/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback, useRef, useEffect } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { injectIntl } from 'react-intl';

function FloorPlanCropComponentRender({ picture, setLoading, canvasRef }) {
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const [crop, setCrop] = useState({ unit: '%' });
  const [completedCrop, setCompletedCrop] = useState(null);

  const onLoad = useCallback(img => {
    imgRef.current = img;
    setLoading(false);
  }, []);

  useEffect(() => {
    const image = imgRef.current;
    const previewCanvas = previewCanvasRef.current;
    if (!image || !previewCanvas || !completedCrop) {
      return;
    }

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    previewCanvas.width = Math.ceil(crop.width * scaleX);
    previewCanvas.height = Math.ceil(crop.height * scaleY);
    const ctx = previewCanvas.getContext('2d');
    canvasRef.current = previewCanvas;
    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );
  }, [completedCrop]);

  return (
    <div className="col-12 pr-0">
      <ReactCrop
        src={picture}
        // imageStyle={{ width: '100%', height: '60%' }}
        onImageLoaded={onLoad}
        crop={crop}
        crossorigin="anonymous"
        onChange={setCrop}
        onComplete={setCompletedCrop}
      />
      <canvas
        className="d-none"
        ref={previewCanvasRef}
        style={{
          width: Math.round(completedCrop?.width ?? 0),
          height: Math.round(completedCrop?.height ?? 0),
        }}
      />
    </div>
  );
}

export default injectIntl(FloorPlanCropComponentRender);
